export const FADE_MS = 250;

/** A black layer for the walk between the lobby and the room (spec 2o §2.1). */
export function mountFade(root: HTMLElement): (dark: boolean) => Promise<void> {
  const el = document.createElement("div");
  el.className = "fade";
  root.appendChild(el);
  return (dark) => new Promise((resolve) => { el.classList.toggle("dark", dark); setTimeout(resolve, FADE_MS); });
}
